import { PropsWithoutRef } from 'react'

import Icon from '@ant-design/icons'
import { IconBaseProps } from '@ant-design/icons/lib/components/Icon'

import { NeImageErrorSvg } from './NeImageErrorSvg'

export const NeImageErrorIcon = (props: PropsWithoutRef<IconBaseProps>) => {
  return <Icon component={NeImageErrorSvg} {...props} />
}
